module.exports = __webpack_public_path__ + "static/img/logo_z_obwodka.07b5b20d.png";